import { render, staticRenderFns } from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=template&id=ee674aae&scoped=true&"
import script from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=style&index=0&id=ee674aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee674aae",
  null
  
)

export default component.exports